const initDeviceData = (clientInstance, selector = '#device_data') => {
    const el = $(selector)
    if (el.val()) { return; }

    window.braintree.dataCollector.create({
        client: clientInstance
    }, function (err, dataCollectorInstance) {
        if (err) {
            console.error(err);
            return;
        }
        el.val(dataCollectorInstance.deviceData);
    });
};

export default initDeviceData
